module.exports = __webpack_public_path__ + "img/energy_icon2.adc214e0.png";